export default function CardFillMetaRow({
	label,
	value,
	onCopy,
	copyValue,
}: {
	label: string;
	value: string | null | undefined;
	onCopy?: (text: string) => void;
	copyValue?: string;
}) {
	const display = value?.trim() ? value : '—';
	const canCopy = Boolean(onCopy && copyValue?.trim());

	return (
		<div className='grid grid-cols-[minmax(0,5.5rem)_1fr] gap-x-2 gap-y-0.5 text-sm min-w-0'>
			<span className='text-muted-foreground text-xs'>{label}</span>
			{canCopy ? (
				<button
					type='button'
					className='text-left break-all hover:bg-accent/60 active:bg-accent rounded-xs px-0.5 -ml-0.5 cursor-pointer select-none'
					onClick={() => onCopy!(copyValue!)}
				>
					{display}
				</button>
			) : (
				<span className='break-all'>{display}</span>
			)}
		</div>
	);
}
